<template>
  <div :style="{ height: height }" class="sellCenter addDiscount">
    <div class="inputWrap">
      <div class="header" ref="header">
        <div class="StoreWallateRechargeTitle">
          <el-page-header @back="goBack" content=""> </el-page-header>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ name: 'discountManage' }"
              ><span class="titleText">优惠管理</span></el-breadcrumb-item
            >
            <el-breadcrumb-item :to="{ name: 'addDiscount' }"
              ><span class="titleText">添加优惠</span></el-breadcrumb-item
            >
          </el-breadcrumb>
        </div>
        <div>
          <el-button type="info" size="mini" @click="onSubmit">
            添加优惠
          </el-button>
        </div>
      </div>

      <div
        :style="{ height: formHeight + 'px', backgroundColor: '#fff' }"
        class="formBox"
      >
        <el-form ref="form" :model="form" size="mini" label-width="80px">
          <div v-if="showErr.show" class="formInfo">
            <el-alert
              v-show="showErr.show"
              :title="showErr.text"
              type="warning"
              :closable="false"
              show-icon
            >
            </el-alert>
          </div>
          <div class="formInnerBox" :style="{ height: formHeight - 40 + 'px' }">
            <el-collapse v-model="activeName" accordion>
              <el-collapse-item
                :title="`1.选择目标客户---已选客户数：${
                  checkedCustomer ? checkedCustomer.length : 0
                }位`"
                name="1"
              >
                <el-form-item label="选择客户：">
                  <el-button
                    @click="toAddcustome"
                    icon="el-icon-plus"
                    size="mini"
                    type="info"
                    >选择目标客户</el-button
                  >
                </el-form-item>
                <el-form-item>
                  <el-table
                    :data="checkedCustomer"
                    border
                    highlight-current-row
                    size="mini"
                    max-height="300px"
                    fit
                    :style="{
                      'background-color': 'transparent',
                      width: '1212px',
                    }"
                    :header-cell-style="{ 'background-color': '#f8f8f8' }"
                  >
                    <el-table-column
                      :label="`已选客户数：${
                        checkedCustomer ? checkedCustomer.length : 0
                      }位`"
                    >
                      <el-table-column
                        align="center"
                        label="序号"
                        type="index"
                        width="50"
                      >
                      </el-table-column>

                      <el-table-column
                        width="150"
                        show-overflow-tooltip
                        align="center"
                        label="操作"
                      >
                        <div slot-scope="scope">
                          <!-- <el-button class="_mini" type="info" size="mini">设置</el-button> -->
                          <!-- <el-button class="_mini" type="info" size="mini"
              >查看库存</el-button
            > -->
                          <el-button
                            @click="() => editcustome(scope.row)"
                            class="_mini"
                            type="info"
                            size="mini"
                            >删除选中</el-button
                          >

                          <!-- <el-button
              class="_mini"
              @click="() => deletecustome(scope.row)"
              type="danger"
              size="mini"
              >删除</el-button
            >
            
            <el-button class="_mini" type="info" size="mini"
              >设置秒杀</el-button
            > -->
                        </div>
                      </el-table-column>

                      <el-table-column
                        show-overflow-tooltip
                        align="center"
                        prop="clientName"
                        label="客户名称"
                        width="150"
                      >
                      </el-table-column>

                      <el-table-column
                        show-overflow-tooltip
                        align="center"
                        prop="clientPhone"
                        label="用户电话"
                        width="150"
                      >
                      </el-table-column>
                      <el-table-column
                        show-overflow-tooltip
                        align="center"
                        prop="balance"
                        label="预付款余额（元）"
                        width="150"
                      >
                      </el-table-column>
                      <el-table-column
                        show-overflow-tooltip
                        align="center"
                        width="130"
                        prop="name"
                        label="客户联系人姓名"
                      >
                      </el-table-column>
                      <el-table-column
                        show-overflow-tooltip
                        align="center"
                        width="150"
                        prop="telphone"
                        label="客户联系人联系电话"
                      >
                      </el-table-column>
                      <el-table-column
                        show-overflow-tooltip
                        align="center"
                        prop="status"
                        label="是否允许货到付款"
                        width="150"
                      >
                        <template slot-scope="scope">
                          <div :class="setClass(scope.row)">
                            <div
                              v-if="scope.row.pay_flag == 1"
                              :style="{ color: '#009e96' }"
                            >
                              是
                            </div>
                            <div v-else>否</div>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        show-overflow-tooltip
                        align="center"
                        width="130"
                        prop="payment_days"
                        label="账期天数"
                      >
                      </el-table-column>
                    </el-table-column>
                  </el-table>
                </el-form-item>
              </el-collapse-item>
              <el-collapse-item
                :title="`2.选择目标商品---已选商品数：${
                  checkedGoods ? checkedGoods.length : 0
                }件`"
                name="2"
              >
                <el-form-item label="选择商品：">
                  <el-button
                    @click="toAddGoods"
                    icon="el-icon-plus"
                    size="mini"
                    type="info"
                    >选择目标商品</el-button
                  >
                </el-form-item>
                <el-form-item>
                  <el-table
                    :data="checkedGoods"
                    border
                    highlight-current-row
                    size="mini"
                    max-height="300px"
                    :style="{
                      'background-color': 'transparent',
                      width: '1242px',
                    }"
                    :header-cell-style="{ 'background-color': '#f8f8f8' }"
                  >
                    <el-table-column
                      :label="`已选商品数：${
                        checkedGoods ? checkedGoods.length : 0
                      }件`"
                    >
                      <el-table-column
                        align="center"
                        label="序号"
                        type="index"
                        width="50"
                      >
                      </el-table-column>

                      <el-table-column
                        width="150"
                        show-overflow-tooltip
                        align="center"
                        label="操作"
                      >
                        <div slot-scope="scope">
                          <!-- <el-button class="_mini" type="info" size="mini">设置</el-button> -->
                          <!-- <el-button class="_mini" type="info" size="mini"
              >查看库存</el-button
            > -->
                          <el-button
                            class="_mini"
                            @click="() => editGoods(scope.row)"
                            type="info"
                            size="mini"
                            >删除选中</el-button
                          >
                          <!-- <el-button
                        @click="() => editGoods(scope.row, scope.$index)"
                        class="_mini"
                        type="info"
                        size="mini"
                        >编辑</el-button
                      >

                      <el-button
                        class="_mini"
                        @click="() => deleteGoods(scope.row)"
                        type="danger"
                        size="mini"
                        >删除</el-button
                      > -->
                          <!--
            <el-button class="_mini" type="info" size="mini"
              >设置秒杀</el-button
            > -->
                        </div>
                      </el-table-column>

                      <el-table-column
                        show-overflow-tooltip
                        align="center"
                        prop="name"
                        label="名称"
                        width="150"
                      >
                      </el-table-column>
                      <el-table-column
                        show-overflow-tooltip
                        align="center"
                        prop="status"
                        label="状态"
                        width="150"
                      >
                        <template slot-scope="scope">
                          <div :class="setClass(scope.row)">
                            {{ statusFormatter(scope.row) }}
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        show-overflow-tooltip
                        align="center"
                        prop="breed"
                        label="品种"
                        width="150"
                      >
                      </el-table-column>
                      <el-table-column
                        show-overflow-tooltip
                        align="center"
                        width="100"
                        prop="goodsType"
                        label="类型"
                      >
                      </el-table-column>
                      <el-table-column
                        show-overflow-tooltip
                        prop="coverPlan"
                        align="center"
                        label="封面"
                        width="100"
                      >
                        <template slot-scope="scope">
                          <el-image
                            style="width: 50px; height: 50px"
                            :src="getImageUrl(scope.row.coverPlan)"
                            fit="cover"
                          ></el-image>
                        </template>
                      </el-table-column>
                      <el-table-column
                        show-overflow-tooltip
                        align="center"
                        width="150"
                        prop="stockCount"
                        label="库存"
                      >
                        <template slot-scope="scope">
                          <div :class="scope.row.stockCount == 0 ? 'red' : ''">
                            {{ scope.row.stockCount || 0
                            }}{{ scope.row.buyUnit }}
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        show-overflow-tooltip
                        align="center"
                        width="150"
                        prop="stockCount"
                        label="单价"
                      >
                        <template slot-scope="scope">
                          <div>
                            {{ scope.row.price || 0 }}元/{{ scope.row.unit }}
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        show-overflow-tooltip
                        align="center"
                        width="90"
                        prop="birthPlace"
                        label="产地"
                      >
                        <template slot-scope="scope">
                          <div>{{ $getAreaInfo(scope.row.birthPlace)[0] }}</div>
                        </template>
                      </el-table-column>
                    </el-table-column>
                  </el-table>
                </el-form-item>
              </el-collapse-item>
              <el-collapse-item title="3.设置折扣" name="3">
                <el-form-item label="选择类型：">
                  <el-radio-group v-model="radio">
                    <el-radio :label="1">打折</el-radio>
                    <el-radio :label="2">购量区间定价</el-radio>
                    <el-radio disabled :label="3">结算额区间赠送</el-radio>
                  </el-radio-group>
                </el-form-item>
                <dir v-if="radio == 1">
                  <el-form-item label="折扣率：">
                    <div class="tipsInfo">
                      针对选中用户及选中商品，设置单件商品折扣率(10折默认不打折)
                    </div>
                  </el-form-item>
                  <el-form-item>
                    <el-input-number
                      v-model="discRate"
                      :min="1"
                      :max="10"
                      label="label"
                    ></el-input-number
                    ><span class="discRateText">折</span>
                  </el-form-item>
                </dir>
                <div v-if="radio == 2">
                  <el-form-item label="区间设置：">
                    <span class="tipsInfo"
                      >单件商品根据销量设置分段价格(件代表计价与购买单位,如kg,袋等)</span
                    >
                  </el-form-item>
                  <div v-for="(item, index) in discList" :key="index">
                    <el-form-item>
                      <div class="zkItemBox">
                        <span class="zkItemBoxLabel">区间{{ index + 1 }}:</span>
                        <div class="numberInput">
                          <el-input
                            v-model="discList[index].min"
                            placeholder="最低销量"
                          >
                            <template slot="append">件</template>
                          </el-input>
                        </div>
                        <span class="fg">-</span>
                        <div class="numberInput">
                          <el-input
                            v-model="discList[index].max"
                            placeholder="最高销量"
                          >
                            <template slot="append">件</template>
                          </el-input>
                        </div>
                        <span class="fg"></span>
                        <div class="numberInput">
                          <el-input
                            v-model="discList[index].price"
                            placeholder="对应单价"
                          >
                            <template slot="append">元/件</template>
                          </el-input>
                        </div>
                        <el-button
                          @click="
                            () => {
                              deleteDisc(index);
                            }
                          "
                          class="deleteBtn"
                          type="text"
                          >删除</el-button
                        >
                      </div>
                    </el-form-item>
                  </div>

                  <el-form-item>
                    <el-button size="mini" @click="addDisc" type="primary"
                      >+ 添加区间</el-button
                    >
                  </el-form-item>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import { addEmpUrl, custlist, getImageUrl, setCustDisc } from "@/api/api";

export default {
  props: ["height"],
  data() {
    return {
      customeList: [],
      value: [],
      form: {
        ID_card: "",
        telphone: "",
      },
      formHeight: "",
      showErr: {
        show: false,
        text: "",
      },
      roleList: [],
      radio: 1,
      discRate: 10,
      number: "",
      discList: [{ min: "", max: "", price: "", giftGid: null }],
    };
  },
  created() {
    this.initCustomData();
  },

  mounted() {
    this.getImageUrl = getImageUrl;
    this.setFormHeight();
    window.addEventListener("resize", this.setFormHeight);
  },
  computed: {
    ...mapState([
      "userInfo",
      "companyInfo",
      "currentEditRow",
      "checkedCustomer",
      "checkedGoods",
    ]),
  },
  methods: {
    ...mapMutations(["saveCheckedCustomer", "saveCheckedGoods"]),
    deleteDisc(index) {
      console.log(index);

      if (this.discList.length > 1) {
        this.discList = this.discList.filter((m, n) => {
          return index != n;
        });
      } else {
        this.$alert("至少保留一个区间", "提示");
      }
      // discList
    },
    addDisc() {
      this.discList = [
        ...this.discList,
        {
          min: "",
          max: "",
          price: "",
          giftGid: null,
        },
      ];
    },
    editcustome(row) {
      console.log(row);
      let checkedCustomer = this.checkedCustomer;
      checkedCustomer = checkedCustomer.filter((item) => {
        return item.clientId != row.clientId;
      });

      this.saveCheckedCustomer(checkedCustomer);
    },
    editGoods(row) {
      console.log(row);
      let checkedGoods = this.checkedGoods;
      checkedGoods = checkedGoods.filter((item) => {
        return item.id != row.id;
      });

      this.saveCheckedGoods(checkedGoods);
    },
    toAddcustome() {
      this.$router.push({ name: "addDiscountCustom" });
    },
    setClass(row) {
      let { status, seckillGoods } = row;
      if (status == 0) {
        return "red";
      } else if (status == "-1") {
        return "purple";
      } else if (status == 1) {
        return "green";
      }
    },
    statusFormatter(row) {
      let { status, seckillGoods } = row;
      let text1 = "";
      let text2 = "";
      if (status == 0) {
        text1 = "已下架";
      } else if (status == "-1") {
        text1 = "已强制下架";
      } else if (status == 1) {
        text1 = "上架中";
      }

      if (seckillGoods) {
        text2 = "秒杀上架中";
        text1 = "";
      }
      return text1 + text2;
    },
    toAddGoods() {
      this.$router.push({ name: "addDiscountGoods" });
    },
    setClass(row) {
      let { status, seckillcustome } = row;
      if (status == 0) {
        return "red";
      } else if (status == "-1") {
        return "purple";
      } else if (status == 1) {
        return "green";
      }
    },
    initCustomData() {
      return;
      this.loading = true;
      let that = this;
      console.log("this.userInfo", this.userInfo);
      let data = {
        access_token: this.userInfo.access_token,
        store_id: this.userInfo.storeId,
        pageIndex: 0,
        pageSize: 999,
      };

      let param = new URLSearchParams();

      for (var k in data) {
        param.append(k, data[k]);
      }

      this.$axios({ method: "post", data: param, url: custlist })
        .then((res) => {
          this.loading = false;
          if (res.data.resultCode == 1) {
            console.log("res.data", res.data.data);
            // that.list = res.data.data;

            this.customeList = res.data.data || [];
            console.log("this.customeList", this.customeList);
          } else {
            this.$alert(`${res.data.resultMsg}`, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$alert("请求异常:" + error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },
    goBack() {
      this.$router.go(-1);
    },
    setFormHeight() {
      setTimeout(() => {
        this.formHeight =
          parseFloat(this.height) - this.$refs.header.clientHeight - 100;
      }, 100);
    },
    getRId() {
      let { checkList } = this.form;
      if (checkList.length) {
        let arr = [];
        this.roleList.filter((item) => {
          let _some = checkList.some((m) => m == item.name);
          if (_some) {
            arr.push(item.id);
          }
        });
        return arr.join(",");
      } else {
        return "4";
      }
    },
    testDiscList() {
      let flag = true;
      this.discList.forEach((item) => {
        if (item.min === "" || item.max === "" || item.price === "") {
          flag = false;
          this.showErr = {
            show: true,
            text: "请设置区间参数",
          };
          return flag;
        }

        if (isNaN(item.min) || isNaN(item.max)) {
          flag = false;

          this.showErr = {
            show: true,
            text: "区间购买量需为正值",
          };
          return flag;
        }

        if (item.min < 0 || item.max < 0 || item.max <= item.min) {
          flag = false;
          this.showErr = {
            show: true,
            text: "区间购买量需为正值，最大值需大于最小值",
          };
          return flag;
        }

        if (item.price <= 0 || isNaN(item.price)) {
          flag = false;
          this.showErr = {
            show: true,
            text: "单价需为正值数字",
          };
          return flag;
        }
        //校验每一个中间值只允许出现在所有的区间内出现一次（出现指的是在区间的内部）
        let midNum = item.min + item.max;
        let t = 0;
        this.discList.forEach((m) => {
          if (midNum < m.max && midNum > m.min) {
            t++;
          }
        });

        if (t > 1) {
          flag = false;
          this.showErr = {
            show: true,
            text: "销售量设置不合理，区间有重叠",
          };
          return flag;
        }
      });

      return flag;
    },
    onSubmit() {
      console.log(this.form);
      let { ID_card, telphone } = this.form;

      if (!this.checkedCustomer || !this.checkedCustomer.length) {
        this.showErr = {
          show: true,
          text: "请选择目标客户",
        };
        return;
      }
      if (!this.checkedGoods || !this.checkedGoods.length) {
        this.showErr = {
          show: true,
          text: "请选择目标商品",
        };
        return;
      }

      if (this.radio == 1) {
        if (isNaN(this.discRate)) {
          this.showErr = {
            show: true,
            text: "折扣率需为数字",
          };
          return;
        }
      }

      if (this.radio == 2) {
        if (!this.testDiscList()) {
          return;
        }
      }

      this.showErr = {
        show: false,
        text: "",
      };

      let { access_token } = this.userInfo;

      // return
      let url = setCustDisc;

      let userIds = this.checkedCustomer
        .map((item) => {
          return item.userId;
        })
        .join(",");
      let goodsIds = this.checkedGoods
        .map((item) => {
          return item.id;
        })
        .join(",");

      let data = {
        access_token,
        userIds,
        goodsIds,
        discType: this.radio,
      };

      if (this.radio == 1) {
        data.discRate = this.discRate;
      } else if (this.radio == 2) {
        data.discJsonArr = JSON.stringify(this.discList);
      }

      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url,
      })
        .then((res) => {
          console.log(res);
          if (res.data.resultCode == 1) {
            const { data } = res.data;
            console.log(data);
            this.$router.go(-1);
            this.saveCheckedCustomer(null)
            this.saveCheckedGoods(null)
            this.$message({
              message: "添加成功",
              type: "success",
            });
          } else {
            this.$alert(JSON.stringify(res.data.resultMsg || "请求异常"));
          }
        })
        .catch((err) => {
          if (err) {
            this.$alert(JSON.stringify(err));
          } else {
            this.$alert("请求异常");
          }
        });
    },
  },
};
</script>
<style scoped lang="less">
.sellCenter {
  overflow: hidden;
}
.warning {
  color: #f40;
  margin-left: 10px;
}
.inputWrap {
  margin: 20px;
}
.formBox {
  margin-top: 20px;
  padding: 20px;
  overflow: scroll;
  margin-bottom: 20px;
}
.forItem {
  width: 266px;
}
// .formInnerBox {
//   display: flex;
//   flex-direction: column;
//   flex-wrap: wrap;
//   align-items: flex-start;
//   max-width: 550px;
// }
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.formInfo {
  display: inline-block;
  height: 30px;
  margin-bottom: 20px;
}
.userName {
  color: #666;
  font-size: 13px;
}
.StoreWallateRechargeTitle {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.numberInput {
  width: 150px;
}
.zkItemBox {
  display: flex;
  flex-direction: row;
}
.fg {
  margin: 0 10px;
}
.zkItemBoxLabel {
  font-size: 12px;
  color: #666;
  margin-right: 10px;
}
.discRateText {
  margin-left: 10px;
  color: "#555";
  font-size: 12px;
}
.deleteBtn {
  margin-left: 10px;
  color: #009e96;
}
.tipsInfo {
  color: #666;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/SellCenter/AddDiscount.vue